import { combineReducers } from 'redux'
import snackbar from './SnackbarReducer'
import progress from './ProgressReducer'
import procurements from './ProcurementsReducer'

const reducers = combineReducers({
	snackbar,
	progress,
	procurements
})

export default reducers


// WEBPACK FOOTER //
// ./src/reducers/index.js